import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import Layout from './components/Layout';
import Home from './pages/Home';
import About from './pages/About';
import Packages from './pages/Packages';
import PackageDetail from './pages/PackageDetail';
import BookPackage from './pages/BookPackage';
import BookingConfirmation from './pages/BookingConfirmation';
import HotDestinations from './pages/HotDestinations';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import Partners from './pages/Partners';
import Consultation from './pages/Consultation';
import Contact from './pages/Contact';
import Terms from './pages/Terms';
import FAQ from './pages/FAQ';
import CustomerAuth from './pages/CustomerAuth';
import CustomerDashboard from './pages/CustomerDashboard';
import TravelerProfile from './pages/TravelerProfile';
import PaymentMethods from './pages/PaymentMethods';
import MyBookings from './pages/MyBookings';
import ClientMicrosite from './pages/ClientMicrosite';
import PackageViewer from './pages/PackageViewer';
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="about" element={<About />} />
            <Route path="packages" element={<Packages />} />
            <Route path="packages/:id" element={<PackageDetail />} />
            <Route path="book/:id" element={<BookPackage />} />
            <Route path="booking/confirmation" element={<BookingConfirmation />} />
            <Route path="destinations" element={<HotDestinations />} />
            <Route path="destinations/:slug" element={<HotDestinations />} />
            <Route path="blog" element={<Blog />} />
            <Route path="blog/:id" element={<BlogPost />} />
            <Route path="partners" element={<Partners />} />
            <Route path="consultation" element={<Consultation />} />
            <Route path="contact" element={<Contact />} />
            <Route path="terms" element={<Terms />} />
            <Route path="faq" element={<FAQ />} />
            <Route path="login" element={<CustomerAuth />} />
            <Route path="register" element={<CustomerAuth />} />
            <Route path="account" element={<CustomerDashboard />}>
              <Route path="profile" element={<TravelerProfile />} />
              <Route path="payments" element={<PaymentMethods />} />
              <Route path="bookings" element={<MyBookings />} />
            </Route>
            <Route path="clients/:slug" element={<ClientMicrosite />} />
          </Route>
          <Route path="/package-viewer" element={<PackageViewer />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/*" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
        </Routes>
        <Toaster position="top-right" />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;